module.exports = __webpack_public_path__ + "images/equipment_head_2.2b77e544.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plan/equipment_head_2.png
// module id = 205
// module chunks = 33